import { createSlice } from '@reduxjs/toolkit';
import { FacebookVideoFileObject } from '../type';

interface FacebookVideoState {
  fileList: FacebookVideoFileObject[];
  cancellationFlags: Record<string, boolean>;
}

const initialState: FacebookVideoState = {
  fileList: [],
  cancellationFlags: {},
};

const facebookVideosSlice = createSlice({
  name: 'facebookVideos',
  initialState,
  reducers: {
    setFileList: (state, action) => {
      state.fileList = action.payload;
    },
    updateFileList: (state, action) => {
      state.fileList = action.payload;
    },
    setCancellationFlag: (state, action) => {
      const { videoId, value } = action.payload;
      state.cancellationFlags[videoId] = value;
    },
    clearCancellationFlag: (state, action) => {
      const { videoId } = action.payload;
      delete state.cancellationFlags[videoId];
    },
    clearAllCancellationFlags: (state) => {
      state.cancellationFlags = {};
    },
  },
});

export const {
  setFileList,
  updateFileList,
  setCancellationFlag,
  clearCancellationFlag,
  clearAllCancellationFlags,
} = facebookVideosSlice.actions;

export default facebookVideosSlice.reducer;
